var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E4F7F8",
    d: "M.118 32.93c0 25.313 27.402 41.134 49.323 28.477a32.88 32.88 0 0 0 16.44-28.476c0-25.313-27.4-41.133-49.322-28.477A32.88 32.88 0 0 0 .12 32.931"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCE7E0",
    d: "M11 54.504c0 1.922 18.333 3.123 33 2.162 6.807-.446 11-1.27 11-2.162 0-1.921-18.333-3.122-33-2.161-6.807.445-11 1.27-11 2.161M57 32.504c0 2.486-1.937 4.5-4.327 4.5H13.334c-3.331 0-5.413-3.75-3.748-6.75.773-1.392 2.202-2.25 3.748-2.25h39.339c2.39 0 4.327 2.015 4.327 4.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M57 32.504c0 2.486-1.937 4.5-4.327 4.5H13.334c-3.331 0-5.413-3.75-3.748-6.75.773-1.392 2.202-2.25 3.748-2.25h39.339c2.39 0 4.327 2.015 4.327 4.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M57 32.504c0 2.486-1.937 4.5-4.327 4.5H13.334c-3.331 0-5.413-3.75-3.748-6.75.773-1.392 2.202-2.25 3.748-2.25h39.339c2.39 0 4.327 2.015 4.327 4.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M57 32.504c0 2.486-1.937 4.5-4.327 4.5H13.334c-3.331 0-5.413-3.75-3.748-6.75.773-1.392 2.202-2.25 3.748-2.25h39.339c2.39 0 4.327 2.015 4.327 4.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M57 32.504c0 2.486-1.937 4.5-4.327 4.5H13.334c-3.331 0-5.413-3.75-3.748-6.75.773-1.392 2.202-2.25 3.748-2.25h39.339c2.39 0 4.327 2.015 4.327 4.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42 28.004H13.306c-3.31 0-5.378 3.75-3.724 6.75.768 1.393 2.188 2.25 3.724 2.25H42z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M42 28.004H13.306c-3.31 0-5.378 3.75-3.724 6.75.768 1.393 2.188 2.25 3.724 2.25H42z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M42 28.004H13.306c-3.31 0-5.378 3.75-3.724 6.75.768 1.393 2.188 2.25 3.724 2.25H42z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M42 28.004H13.306c-3.31 0-5.378 3.75-3.724 6.75.768 1.393 2.188 2.25 3.724 2.25H42z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M42 28.004H13.306c-3.31 0-5.378 3.75-3.724 6.75.768 1.393 2.188 2.25 3.724 2.25H42z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M42 28.004H13.306c-3.31 0-5.378 3.75-3.724 6.75.768 1.393 2.188 2.25 3.724 2.25H42z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M42 28.004H13.306c-3.31 0-5.378 3.75-3.724 6.75.768 1.393 2.188 2.25 3.724 2.25H42z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M42 28.004H13.306c-3.31 0-5.378 3.75-3.724 6.75.768 1.393 2.188 2.25 3.724 2.25H42z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M42 28.004H13.306c-3.31 0-5.378 3.75-3.724 6.75.768 1.393 2.188 2.25 3.724 2.25H42z"
  })));
};
export default SvgLoading;